import moment from 'moment-timezone';
import { ianaToWin } from './iana-to-win';
import { winToIana } from './win-to-iana';

const defaultTimezone = 'America/New_York';

export function getBrowserTimezone() {
  var timezone = moment.tz.guess();

  return getSupportedTimezone(timezone) || defaultTimezone;
}

export function getSupportedTimezone(timezone) {
  return winToIana(ianaToWin(timezone));
}
